/**
 * A response parser for the API exporer
 */
class Response {
  // takes an explorer and a html response
  constructor(explorer, htmlResponse) {
    this.explorer = explorer
    this.htmlResponse = htmlResponse
  }

  // parses and renders the response
  async process() {
    // set the basic UI once we stoped executing
    this.explorer.setExecuting(false)
    this.explorer.setSuccess(this.htmlResponse.ok)
    this.explorer.setStatusCode(this.htmlResponse.status)

    this.explorer.setRenderedHeaders(await this.renderedHeaders())

    if (this.isJson()) {
      this.explorer.setRenderedResponse(await this.renderedResponse())
    }

    this.scrollToResponse()
  }

  // PRIVATE

  isJson() {
    return this.htmlResponse.headers.get("Content-Type") === "application/json"
  }

  // renders the headers for the response
  async renderedHeaders() {
    // parse the headers into an object
    const htmlHeaders = Array.from(this.htmlResponse.headers.entries())
    if (!htmlHeaders.length) {
      return null
    }

    const headers = htmlHeaders.reduce((object, [key, value]) => {
      object[key] = value
      return object
    }, {})

    // serialize and highlight the headers as yaml
    return Object.keys(headers)
      .map((key) => `${key}: ${headers[key]}`)
      .join("\n")
  }

  // render the json response body
  async renderedResponse() {
    // get the json body
    const json = await this.htmlResponse.json()
    if (!Object.entries(json).length) {
      return null
    }

    // serialize and highlight the response body
    return JSON.stringify(json, null, 2)
  }

  // once a response has been rendered, scroll to the response
  scrollToResponse() {
    const selected = document.querySelector("#response-output")
    selected && selected.scrollIntoView({ block: "start", behavior: "smooth" })
  }
}

export default Response
